
import Select from "react-select"
import { useEffect, useState } from "react"
import { Star } from "../../Components/CommoComponent/Star"
import { AssignJEDDLAPI, AssignJEDEDDLAPI } from "../../Redux/DDLSlice"
import { useAuthState } from "../../Helper/Context/context"
import { useDispatch, useSelector } from "react-redux"
import { MultiSelect } from "react-multi-select-component"

export default function AssignJEDDL(props) {
    const { SelectedJE, setSelectedJE, setAssignJEDDL,setJETypeData, handleAssignJEData, DDLFlag, editData, apiFlag, PopUpField, mendetary, departmentDDL, wardNameDDL } = props

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [Options, setOptions] = useState([]);

    useEffect(() => {
        const data = {
            T_ProjectDetailsID: apiFlag == "Update" ? editData?.t_ProjectDetailsID : 0,
            M_UsersID: UserID,
            Flag: DDLFlag,
            M_WardID: wardNameDDL.ID,
            token: token,
            handleData: handleData,
            apiFlag: apiFlag,
        }
        dispatch(AssignJEDEDDLAPI({ data }))
    }, [wardNameDDL.ID, DDLFlag])

    const { AssignJEData, isLoading } = useSelector(state => state.AssignJEDEDDLData)

    const handleData = (val) => {
        const AssignJEDDLData = val.map(i => ({
            value: i.id,
            label: i.employeeName,
            isCheck: i?.isChecked
        }));
        setOptions(AssignJEDDLData);
        if (apiFlag == 'Update') {
            const preSelected = AssignJEDDLData.filter(item => item.isCheck);
            setSelectedJE(preSelected);
            setJETypeData(AssignJEDDLData.map(item => item.value));
        }
    }

    const handleChange = (e) => {
        setSelectedJE(e);
        setJETypeData(e.map(item => item.value));
    };

    return (
        <>
            <div className="">
                <label className="d-block" htmlFor="Budgettype" style={{ fontWeight: 'bold' }}>Assign JE {mendetary === 'yes' ? <Star /> : ''}</label>

                <MultiSelect
                    options={Options}
                    value={SelectedJE}
                    onChange={(e) => handleChange(e)}
                    labelledBy="Select..."
                    isLoading={isLoading}
                />

                {/* <Select
                    isClearable
                    isSearchable
                    maxMenuHeight={140}
                    value={{ value: assignJEDDL.ID, label: assignJEDDL.Label }}
                    onChange={(e) => {
                        e ?
                            setAssignJEDDL({ ...assignJEDDL, ID: e.value, Label: e.label })
                            :
                            setAssignJEDDL({ ...assignJEDDL, ID: 0, Label: "Select..." })
                    }}
                    options={assignJEDDL.DDL}
                /> */}
            </div>
        </>
    )
}